import { style } from '@vanilla-extract/css';

export const postCommentsElement = style({});

export const textarea = style({
  '::placeholder': {
    color: 'var(--textarea-placeholder-color)',
  },
});

export const button = style({});

export const authorBorder = style({
  border: 'solid 1px var(--comments-form-author-border-color)',
});
